import React from "react";
import axios from "axios";
import CurrencySymbol from "../../Components/common/CurrencySymbol";
import { useDispatch } from "react-redux";
import { checkPrivileges, downloadFileName } from "../../Helpers";
import Button from "../../Components/common/Button";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ReactComponent as CheckIcon } from "../../assets/dashboard/check.svg";
import { ReactComponent as DeleteIcon } from "../../assets/dashboard/trash.svg";
import { ReactComponent as CrossIcon } from "../../images/cross.svg";
import { ReactComponent as EditIcon } from "../../assets/dashboard/edit.svg";
import { ReactComponent as CustomerIcon } from "../../assets/services/customer-icon-01.svg";
import { ReactComponent as IssueInvoiceIcon } from "../../assets/services/issue-invoice.svg";
import { ReactComponent as GarageIcon } from "../../assets/services/garage-icon-01-01.svg";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import GetAppIcon from "@mui/icons-material/GetApp";
import LinkIcon from "@mui/icons-material/Link";
import moment from "moment";
import { Tooltip, Box, Typography, Avatar, TextField } from "@mui/material";
import { useState } from "react";
import MenuItem from "../../Components/common/MenuItem";
import Menu from "../../Components/Menu/CommonMenu";
import MailIcon from "@mui/icons-material/Mail";
import SendIcon from "@mui/icons-material/Send";
import { notifyError } from "../../Utils/CustomNotifcations";
import { withStyles } from "@mui/styles";
import SpeedIcon from "@mui/icons-material/Speed";
import RuleRoundedIcon from "@mui/icons-material/RuleRounded";
import PaymentIcon from "@mui/icons-material/Payment";
import {
  initiateBookingTapPayment,
  isPaidFalse,
  isPrepaidTrue,
} from "../Payments/tapPaymentHelpers";
const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const STATUS_COLORS = {
  GarageInitiate: {
    background: "#1879EB1A",
    border: "#1879EB",
    text: "#1879EB",
    dot: "#1879EB",
  },
  WaitingForOpApproval: {
    background: "#F69B241A",
    border: "#F69B24",
    text: "#F69B24",
    dot: "#F69B24",
  },
  GarageToOp: {
    background: "#F69B241A",
    border: "#F69B24",
    text: "#F69B24",
    dot: "#F69B24",
  },
  WaitingForCustomerApproval: {
    background: "#6366F11A",
    border: "#6366F1",
    text: "#6366F1",
    dot: "#6366F1",
  },
  OpToCustomer: {
    background: "#6366F11A",
    border: "#6366F1",
    text: "#6366F1",
    dot: "#6366F1",
  },
  GarageToCustomer: {
    background: "#6366F11A",
    border: "#6366F1",
    text: "#6366F1",
    dot: "#6366F1",
  },
  required: {
    background: "#1879EB1A",
    border: "#1879EB",
    text: "#1879EB",
    dot: "#1879EB",
  },
  completed: {
    background: "#6FBD431A",
    border: "#6FBD43",
    text: "#6FBD43",
    dot: "#6FBD43",
  },
  scheduled: {
    background: "#6FBD431A",
    border: "#6FBD43",
    text: "#6FBD43",
    dot: "#6FBD43",
  },
  CustomerToOp: {
    background: "#E33C301A",
    border: "#E33C30",
    text: "#E33C30",
    dot: "#E33C30",
  },
  CustomerToGarage: {
    background: "#E33C301A",
    border: "#E33C30",
    text: "#E33C30",
    dot: "#E33C30",
  },
  expired: {
    background: "#78716C1A",
    border: "#78716C",
    text: "#78716C",
    dot: "#78716C",
  },
  default: {
    background: "#F57C001A",
    border: "#F57C00",
    text: "#F57C00",
    dot: "#F57C00",
  },
};

const getStatusColors = (status) => {
  return STATUS_COLORS[status] || STATUS_COLORS.default;
};

const getInspectionTokens = (inspectionToken) => {
  if (!inspectionToken || inspectionToken === "null") return [];
  return String(inspectionToken)
    .split(",")
    .map((token) => token.trim())
    .filter(Boolean);
};

const MaintenanceItem = React.memo(
  ({
    type,
    ServerSetting,
    imagePopup,
    translate,
    data,
    onRemove,
    onEdit,
    onMarkComplete,
    logInUser,
    index,
    editHistoryFrom,
    serverTimeZone,
    openStatusFrom,
    estimation,
    tabBtn,
    openServiceMarkCompleteBox,
    openSendToGarageBox,
    openMessageLogs,
    openIssueInvoiceBox,
    serverTimeZoneName,
    themecolors,
  }) => {
    const statusObj = {
      required: "due",
      expired: "overdue",
      completed: "completed",
      schedule: "scheduled",
    };
    const [collapsed, setCollapsed] = useState(index === 0 ? true : false);
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();

    const handleMenuClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    const startOnlinePayment = () => {
      const bookingId = data?.id;
      const amount = parseFloat(data?.cost) || 0;
      if (!bookingId) {
        dispatch(notifyError("somethingWentWrong"));
        return;
      }
      const tapWindow = window.open("about:blank", "_blank");
      initiateBookingTapPayment({
        dispatch,
        ServerSetting,
        logInUser,
        bookingId,
        amount,
        description: data?.name || data?.workOrderNumber || "",
        tapWindow,
      }).catch(() => {});
    };

    const downloadWorkOrder = (item) => {
      const pdfTitle = downloadFileName(
        [
          item?.name,
          data?.id,
          item?.workOrderNumber,
          data?.workOrderNumber,
          item?.jobCardNumber,
          data?.jobCardNumber,
          item?.estimateNumber,
          data?.estimateNumber,
        ],
        "pdf",
        item?.creationMode === "garage" ? "Estimation" : "WorkOrder",
      );

      if (type === "history") {
        downloadInvoicePdf();
      } else {
        axios({
          method: "GET",
          url: `/api/services/workorder/export?token=${data.token}`,
          headers: {
            Accept: "application/pdf",
          },
          responseType: "blob",
        })
          .then((response) => {
            if (response.data.size) {
              const a = document.createElement("a");
              const url = window.URL.createObjectURL(new Blob([response.data]));
              a.setAttribute("download", pdfTitle);
              document.body.appendChild(a);
              a.href = url;
              a.click();
            } else {
              dispatch(notifyError("somethingWentWrong"));
            }
          })
          .catch((error) => {
            dispatch(notifyError("somethingWentWrong"));
          });
      }
    };

    const downloadInvoicePdf = () => {
      let invoice =
        ServerSetting && ServerSetting.contractType === 1
          ? "deliverynotes"
          : ServerSetting.contractType === 2
            ? "leaseinvoices"
            : "invoices";

      const fileName = downloadFileName(
        invoice === "deliverynotes"
          ? [data?.deliveryNoteNumber, data?.deliveryNoteRefNumber]
          : [data?.invoiceNumber, data?.invoiceRefNumber],
        "pdf",
        invoice === "deliverynotes" ? "deliverynote" : "invoice",
      );

      axios({
        method: "GET",
        url: `/api/${invoice}/export/${data.invoiceId}`,
        headers: {
          Accept: "application/pdf",
        },
        responseType: "blob",
      })
        .then((response) => {
          if (response.data.size) {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(new Blob([response.data]));
            a.setAttribute("download", fileName);
            document.body.appendChild(a);
            a.href = url;
            a.click();
          } else {
            dispatch(notifyError("somethingWentWrong"));
          }
        })
        .catch((error) => {
          console.log("er =", error);
          dispatch(notifyError("somethingWentWrong"));
        });
    };

    const downloadAttachmentFile = (item) => {
      const fileValue = item?.files;
      if (!fileValue || typeof fileValue !== "string" || !fileValue.trim()) {
        dispatch(notifyError("somethingWentWrong"));
        return;
      }

      let href = fileValue.trim();
      let fileName = "attachment";

      if (href.startsWith("http://") || href.startsWith("https://")) {
        fileName = href.split("/").pop()?.split("?")[0] || "attachment";
      } else if (href.startsWith("data:")) {
        const mimeMatch = href.match(/^data:([^;,]+)/);
        const mime = mimeMatch?.[1] || "";
        if (mime.includes("pdf")) fileName = "attachment.pdf";
        else if (mime.includes("png")) fileName = "attachment.png";
        else if (mime.includes("jpeg") || mime.includes("jpg"))
          fileName = "attachment.jpg";
        else if (mime.includes("webp")) fileName = "attachment.webp";
        else fileName = "attachment";
      } else {
        // Raw base64 without data URI prefix
        href = `data:application/octet-stream;base64,${href}`;
        fileName = "attachment";
      }

      const a = document.createElement("a");
      a.href = href;
      a.setAttribute("download", fileName);
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener noreferrer");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    const viewInvoice = (item) => {
      let leasing = ServerSetting.contractType === 1 ? false : true;
      let timezone = serverTimeZone || "Asia/Riyadh";
      let invoiceType =
        ServerSetting.contractType === 1 ? "delivery-detail" : "invoiceDetail";

      if (item.creationMode === "garage") {
        window.open(`estimation.html?token=${data.token}`, "_blank");
      } else {
        if (type === "history") {
          window.open(
            `${invoiceType}?&token=${data.invoiceId}&leasing=${leasing}&timezone=${timezone}`,
            "_blank",
          );
        } else {
          window.open(`workOrder.html?token=${data.token}`, "_blank");
        }
      }
    };

    const inspectionTokens = getInspectionTokens(
      data?.attributes?.inspectionToken,
    );

    const openInspectionView = (token) => {
      if (!token) return;
      const siantyUrl = "https://my.sianty.com/inspection/view/";
      window.open(`${siantyUrl}${token}`, "_blank");
    };

    // const shouldShowSubmitToOps = true;
    // const shouldShowSendToCustomer = true;
    // const shouldShowReject = true;
    // const shouldShowApprove = true;

    const shouldShowSubmitToOps =
      (logInUser.customerType === 1 &&
        checkPrivileges("serviceGarageToOp") &&
        (data.status === "GarageInitiate" ||
          data.status === "OpToGarage" ||
          data.status === "CustomerToGarage")) ||
      ((logInUser.customerType === 3 ||
        logInUser.userType === 2 ||
        logInUser.userType === 1 ||
        logInUser.userType === 3) &&
        checkPrivileges("serviceCustomerToOp") &&
        (data.status === "OpToCustomer" ||
          data.status === "GarageToCustomer" ||
          data.status === "WaitingForCustomerApproval"));

    const shouldShowSendToCustomer =
      (logInUser.customerType === 1 &&
        checkPrivileges("serviceGarageToCustomer") &&
        (data.status === "GarageInitiate" ||
          data.status === "OpToGarage" ||
          data.status === "CustomerToGarage")) ||
      (logInUser.customerType === 2 &&
        checkPrivileges("serviceOpToCustomer") &&
        (data.status === "GarageToOp" ||
          data.status === "CustomerToOp" ||
          data.status === "WaitingForOpApproval"));

    const shouldShowReject =
      (logInUser.customerType === 2 &&
        checkPrivileges("serviceOpToGarage") &&
        (data.status === "GarageToOp" ||
          data.status === "CustomerToOp" ||
          data.status === "WaitingForOpApproval")) ||
      ((logInUser.customerType === 3 ||
        logInUser.userType === 2 ||
        logInUser.userType === 1 ||
        logInUser.userType === 3) &&
        checkPrivileges("serviceCustomerToGarage") &&
        (data.status === "WaitingForCustomerApproval" ||
          data.status === "OpToCustomer" ||
          data.status === "GarageToCustomer"));

    const shouldShowApprove =
      (logInUser.customerType === 3 ||
        logInUser.userType === 2 ||
        logInUser.userType === 1 ||
        logInUser.userType === 3) &&
      checkPrivileges("serviceCustomerAccept") &&
      (data.status === "WaitingForCustomerApproval" ||
        data.status === "OpToCustomer" ||
        data.status === "GarageToCustomer");

    const shouldShowCustomerApproveOp =
      checkPrivileges("serviceCustomerApproveOp") &&
      (data.status === "OpToCustomer" || data.status === "GarageToCustomer");

    const requestHistory = type === "due" ? true : false;

    const statusColors = getStatusColors(data.status);
    const hasValue = (value) =>
      value !== undefined && value !== null && value !== "" && value !== "null";

    // Priority: workOrderNumber -> jobCardNumber -> estimateNumber
    const documentNumber = hasValue(data?.workOrderNumber)
      ? { label: "wo", value: data.workOrderNumber }
      : hasValue(data?.jobCardNumber)
        ? { label: "jc", value: data.jobCardNumber }
        : hasValue(data?.estimateNumber)
          ? { label: "es", value: data.estimateNumber }
          : null;
    return (
      <>
        {estimation ? (
          <Box
            className={"mainten-section mainten-" + statusObj[data.status]}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            {/* Column 1: Vehicle Badge */}
            <Box
              sx={{ minWidth: "150px", maxWidth: "180px", flex: "1 1 150px" }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    backgroundColor: "#303A49",
                    borderRadius: 1,
                    padding: "5px 12px",
                    width: "100%",
                    maxWidth: "130px",
                  }}
                >
                  {/* <Tooltip
                    title={
                      <Box sx={{ padding: "5px 0px" }}>
                        <Box
                          sx={{
                            borderBottom: "1px solid lightGray",
                            padding: "1px 0px",
                          }}
                        >
                          Garage Info
                        </Box>
                        <Box sx={{ marginTop: "5px" }}>
                          {data?.attributes?.g_email && (
                            <Typography variant="body2">
                              {data.attributes.g_email}
                            </Typography>
                          )}
                          {data?.attributes?.g_name && (
                            <Typography variant="body2">
                              {data.attributes.g_name}
                            </Typography>
                          )}
                          {data?.attributes?.g_contact && (
                            <Typography variant="body2">
                              {data.attributes.g_contact}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    }
                    arrow
                    placement="bottom"
                  ></Tooltip> */}
                  {data?.attributes?.g_email || data?.attributes?.g_name ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <AirportShuttleIcon
                          sx={{
                            color: "#6FBD43",
                            fontSize: 16,
                            flexShrink: 0,
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#fff",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1,
                          }}
                          title={data.vehicleLicensePlate}
                        >
                          {data.vehicleLicensePlate}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <SpeedIcon
                          sx={{
                            color: "#6FBD43",
                            fontSize: 16,
                            flexShrink: 0,
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: 10,
                            fontWeight: 500,
                            color: "#fff",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1,
                          }}
                          title={`Odometer: ${new Intl.NumberFormat().format(data?.odometer ?? 0)}`}
                        >
                          {new Intl.NumberFormat().format(data?.odometer ?? 0)}
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <AirportShuttleIcon
                          sx={{ color: "#6FBD43", fontSize: 16, flexShrink: 0 }}
                        />
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#fff",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1,
                          }}
                          title={data.vehicleLicensePlate}
                        >
                          {data.vehicleLicensePlate}
                        </Typography>
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <SpeedIcon
                          sx={{ color: "#6FBD43", fontSize: 16, flexShrink: 0 }}
                        />
                        <Typography
                          sx={{
                            fontSize: 10,
                            fontWeight: 500,
                            color: "#fff",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1,
                          }}
                          title={`Odometer: ${new Intl.NumberFormat().format(data?.odometer ?? 0)}`}
                        >
                          {new Intl.NumberFormat().format(data?.odometer ?? 0)}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>

                {inspectionTokens.length === 1 && (
                  <Button
                    size="small"
                    variant="outlined"
                    style={{
                      fontSize: "0.65rem",
                      padding: "4px 8px",
                      textTransform: "none",
                      maxWidth: "130px",
                    }}
                    onClick={() => openInspectionView(inspectionTokens[0])}
                  >
                    Inspection
                  </Button>
                )}
                {inspectionTokens.length > 1 && (
                  <TextField
                    select
                    size="small"
                    value=""
                    SelectProps={{ displayEmpty: true }}
                    onChange={(e) => openInspectionView(e.target.value)}
                    sx={{
                      maxWidth: "130px",
                      "& .MuiOutlinedInput-root": {
                        fontSize: "0.65rem",
                      },
                      "& .MuiSelect-select": {
                        padding: "4px 8px",
                        textTransform: "none",
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      Inspection
                    </MenuItem>
                    {inspectionTokens.map((token, idx) => (
                      <MenuItem key={token} value={token}>
                        {`Inspection ${idx + 1}`}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Box>
            </Box>

            {/* Column 2: Icon + ID + Date */}
            <Box
              sx={{ minWidth: "100px", flex: "1 1 100px", maxWidth: "150px" }}
            >
              <Box>
                <Typography
                  sx={{ fontSize: 12, fontWeight: 600, color: "#000" }}
                >
                  #{data.id}
                </Typography>
                <Typography
                  sx={{ fontSize: 12, color: "#525252", fontStyle: "italic" }}
                >
                  {data.createdTime
                    ? moment(data.createdTime)
                        .tz(serverTimeZoneName)
                        .format("DD - MM - YYYY")
                    : "--"}
                </Typography>
              </Box>
            </Box>

            {/* Column 3: Work Order Name + Estimate ID */}
            <Box
              sx={{
                flex: "1 1 150px",
                minWidth: "150px",
                maxWidth: "300px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Avatar
                sx={{
                  backgroundColor: "#1E72B8",
                  width: 32,
                  height: 32,
                }}
              >
                <HtmlTooltip
                  title={
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: "bold",
                        padding: "5px 0px",
                      }}
                    >
                      {data.creationMode === "user"
                        ? translate("createdbyUser")
                        : data.creationMode === "garage"
                          ? translate("createdbyGarage")
                          : ""}
                    </Typography>
                  }
                >
                  {data.creationMode === "user" ? (
                    <GarageIcon width={18} height={18} />
                  ) : data.creationMode === "garage" ? (
                    <CustomerIcon width={18} height={18} />
                  ) : (
                    <CustomerIcon width={18} height={18} />
                  )}
                </HtmlTooltip>
              </Avatar>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: 0,
                  flex: 1,
                }}
              >
                <Box sx={{ marginBottom: "1px" }}>
                  <Tooltip placement="right" title={translate(data.name)}>
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#525252",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {data.name}
                    </Typography>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: 12,
                    color: "#949494",
                    maxWidth: "130px",
                  }}
                >
                  <Typography
                    component="span"
                    sx={{ whiteSpace: "nowrap", fontSize: 12 }}
                  >
                    {documentNumber ? translate(documentNumber.label) : ""}
                  </Typography>
                  <Tooltip
                    placement="right"
                    title={
                      documentNumber ? translate(documentNumber.value) : ""
                    }
                  >
                    <Typography
                      component="span"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: 12,
                      }}
                    >
                      {documentNumber ? `#${documentNumber.value}` : ""}
                    </Typography>
                  </Tooltip>
                </Box>
              </Box>
            </Box>

            {/* Column 4: Status Badge */}
            <Box
              sx={{ minWidth: "180px", flex: "1 1 180px", maxWidth: "250px" }}
            >
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "4px 14px",
                  borderRadius: "20px",
                  justifyContent: "center",
                  backgroundColor: statusColors.background,
                  border: `1px solid ${statusColors.border}`,
                }}
              >
                <Box
                  component="span"
                  sx={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    marginRight: 1,
                    flexShrink: 0,
                    backgroundColor: statusColors.dot,
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: statusColors.text,
                  }}
                >
                  {translate(
                    data.status === "required"
                      ? "customerApprove"
                      : data.status === "expired"
                        ? "overdue"
                        : data.status === "GarageToOp"
                          ? "WaitingForOpApproval"
                          : data.status === "GarageToCustomer" ||
                              data.status === "OpToCustomer"
                            ? "WaitingForCustomerApproval"
                            : data.status === "OpToGarage"
                              ? "RejectedByOP"
                              : data.status === "CustomerToOp" ||
                                  data.status === "CustomerToGarage"
                                ? "RejectedByCustomer"
                                : data.status,
                  )}
                </Typography>
              </Box>
            </Box>

            {/* Column 5: Cost */}
            <Box
              sx={{ minWidth: "100px", flex: "1 1 100px", maxWidth: "120px" }}
            >
              <Typography
                component="span"
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: themecolors?.themeLightColor || "#1976d2",
                }}
              >
                {data.saleNetAmount?.toFixed(2)}{" "}
              </Typography>
              <Typography
                component="span"
                sx={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: "#525252",
                  fontStyle: "italic",
                }}
              >
                <CurrencySymbol
                  currency={logInUser?.attributes?.currencyLabel}
                  withParentheses={false}
                />
              </Typography>
            </Box>

            {/* Column 6: Action Buttons */}
            <Box
              sx={{
                minWidth: "220px",
                flex: "1 1 220px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              {/* Primary Action Button */}
              {shouldShowSubmitToOps && (
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    backgroundColor: themecolors?.themeLightColor || "#1976d2",
                    color: "#fff",
                    textTransform: "none",
                    fontSize: "12px",
                    padding: "6px 16px",
                    minWidth: "120px",
                    boxShadow: "none",
                    marginRight: shouldShowSendToCustomer ? 8 : 0, // spacing
                  }}
                  onClick={() => openStatusFrom([data], "sendToOp")}
                >
                  {translate("sendToOp")}
                </Button>
              )}

              {shouldShowSendToCustomer && (
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    backgroundColor: themecolors?.themeLightColor || "#1976d2",
                    color: "#fff",
                    textTransform: "none",
                    fontSize: "12px",
                    padding: "6px 16px",
                    minWidth: "120px",
                    boxShadow: "none",
                  }}
                  onClick={() => openStatusFrom([data], "sendToCust")}
                >
                  {translate("sendToCust")}
                </Button>
              )}

              {/* Reject Button */}
              {shouldShowReject && (
                <IconButton
                  size="small"
                  sx={{
                    backgroundColor: "#E33C3033",
                    color: "#E33C30",
                    width: 30,
                    height: 30,
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#E33C3055",
                    },
                  }}
                  onClick={() => openStatusFrom([data], "sendToGarage")}
                >
                  <Tooltip title={translate("reject")}>
                    <CrossIcon width={14} height={14} />
                  </Tooltip>
                </IconButton>
              )}

              {shouldShowApprove && (
                <IconButton
                  size="small"
                  sx={{
                    backgroundColor: "#10A95733",
                    color: "#10A957",
                    width: 30,
                    height: 30,
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#10A95755",
                    },
                  }}
                  onClick={() => openStatusFrom([data], "accept")}
                >
                  <Tooltip title={translate("partialApproval")}>
                    <RuleRoundedIcon width={20} height={20} />
                  </Tooltip>
                </IconButton>
              )}

              {/* Full Approval Button */}
              {shouldShowApprove && (
                <IconButton
                  size="small"
                  style={{
                    backgroundColor: "#10A957",
                    width: 30,
                    color: "#fff",

                    height: 30,
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#10A95755",
                    },
                  }}
                  onClick={() => openStatusFrom([data], "accept", true)}
                >
                  <Tooltip title={translate("fullApproval")}>
                    <CheckIcon width={20} height={20} />
                  </Tooltip>
                </IconButton>
              )}

              {shouldShowCustomerApproveOp && (
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    backgroundColor: themecolors?.themeLightColor || "#1976d2",
                    color: "#fff",
                    textTransform: "none",
                    fontSize: "12px",
                    padding: "6px 16px",
                    minWidth: "120px",
                    boxShadow: "none",
                  }}
                  onClick={() => openStatusFrom([data], "customerApproveOp")}
                >
                  {translate("customerApproveOp")}
                </Button>
              )}

              {/* Approve Button (Partial Approval) */}

              {/* Three-dot Menu */}
              <IconButton
                size="small"
                sx={{
                  backgroundColor: "#37474F",
                  color: "#fff",
                  width: 30,
                  height: 30,
                  borderRadius: 1,
                  "&:hover": {
                    backgroundColor: "#455A64",
                  },
                }}
                onClick={handleMenuClick}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
              {/* Menu Component */}
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                {/* Issue Invoice */}
                {checkPrivileges("serviceIssueDeliveryNote") &&
                  (data.status === "required" || data.status === "completed") &&
                  (data.issueInvoice === undefined ||
                    data.issueInvoice === false) && (
                    <MenuItem
                      onClick={() => {
                        handleMenuClose();
                        openIssueInvoiceBox([data]);
                      }}
                    >
                      <IssueInvoiceIcon
                        width={18}
                        height={18}
                        style={{ marginRight: 8 }}
                      />
                      {translate("issueInvoice")}
                    </MenuItem>
                  )}

                {/* Online payment for unpaid prepaid bookings */}
                {isPrepaidTrue(data?.prePaid ?? data?.prepaid) &&
                  isPaidFalse(data?.paid) && (
                    <MenuItem
                      onClick={() => {
                        handleMenuClose();
                        startOnlinePayment();
                      }}
                    >
                      <PaymentIcon
                        fontSize="small"
                        style={{ marginRight: 8 }}
                      />
                      {translate("onlinePayment") || "Online Payment"}
                    </MenuItem>
                  )}

                {/* Send to Garage */}
                {checkPrivileges("serviceSendToGarage") &&
                  (data.status === "required" || data.status === "completed") &&
                  !data.bookingMessegeDex &&
                  !data.bookingMessegeMac && (
                    <MenuItem
                      onClick={() => {
                        handleMenuClose();
                        openSendToGarageBox([data]);
                      }}
                    >
                      <SendIcon
                        width={18}
                        height={18}
                        style={{ marginRight: 8 }}
                      />
                      {translate("sendToGarage")}
                    </MenuItem>
                  )}

                {/* Mark as Complete */}
                {checkPrivileges("serviceMarkAsComplete") &&
                  data.status === "required" && (
                    <MenuItem
                      onClick={() => {
                        handleMenuClose();
                        openServiceMarkCompleteBox([data]);
                      }}
                    >
                      <CheckIcon
                        width={18}
                        height={18}
                        style={{ marginRight: 8 }}
                      />
                      {translate("markAsComplete")}
                    </MenuItem>
                  )}

                {/* View Invoice/Work Order */}
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    viewInvoice(data);
                  }}
                >
                  <LinkIcon fontSize="small" style={{ marginRight: 8 }} />
                  {type === "history"
                    ? ServerSetting.contractType === 1
                      ? translate("ViewWorkDeliveryNote")
                      : translate("ViewWorkInvoice")
                    : translate("viewWorkOrder")}
                </MenuItem>

                {/* Download PDF */}
                {(type === "history" ? data.invoiceId !== 0 : true) && (
                  <MenuItem
                    onClick={() => {
                      handleMenuClose();
                      downloadWorkOrder(data);
                    }}
                  >
                    <PictureAsPdf fontSize="small" style={{ marginRight: 8 }} />
                    {type === "history"
                      ? translate("downloadInvoice")
                      : translate("downloadWorkOrder")}
                  </MenuItem>
                )}

                {/* Download attached file */}
                {data.files && String(data.files).trim() !== "" && (
                  <MenuItem
                    onClick={() => {
                      handleMenuClose();
                      downloadAttachmentFile(data);
                    }}
                  >
                    <GetAppIcon fontSize="small" style={{ marginRight: 8 }} />
                    {translate("downloadFile")}
                  </MenuItem>
                )}

                {/* Show Service Logs */}
                {data.creationMode === "garage" && (
                  <MenuItem
                    onClick={() => {
                      handleMenuClose();
                      openMessageLogs([data]);
                    }}
                  >
                    <MailIcon fontSize="small" style={{ marginRight: 8 }} />
                    {translate("showServiceLogs")}
                  </MenuItem>
                )}

                {/* Edit */}
                {/* {data.creationMode === "user" && (
                  <MenuItem onClick={() => { handleMenuClose(); onEdit([data], requestHistory); }}>
                    <EditIcon width={18} height={18} style={{ marginRight: 8 }} />
                    {translate("edit")}
                  </MenuItem>
                )} */}

                {/* Delete */}
                {(data.creationMode === "user" ||
                  (data.creationMode === "garage" &&
                    data.status === "GarageInitiate" &&
                    logInUser.customerType === 1)) && (
                  <MenuItem
                    onClick={() => {
                      handleMenuClose();
                      onRemove([data]);
                    }}
                  >
                    <DeleteIcon
                      width={18}
                      height={18}
                      style={{ marginRight: 8 }}
                    />
                    {translate("delete")}
                  </MenuItem>
                )}
              </Menu>
            </Box>
          </Box>
        ) : null}
      </>
    );
  },
);

export default MaintenanceItem;
